<template>
  <div class="custom-main custom-theme">
    <a-spin :spinning="loading" :tip="loadTip">
      <a-form class="ant-advanced-search-form">
        <a-row class="searchrow width-style-auto">
          <a-form-item label="药品类型">
            <a-select v-model="search.type">
              <a-select-option value="">--请选择--</a-select-option>
              <a-select-option v-for="item in init.types" :key="item.name" :value="item.name">
                {{ item.value }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="药品归属">
            <a-select v-model="search.hq">
              <a-select-option value="">--请选择--</a-select-option>
              <a-select-option value="1">总部</a-select-option>
              <a-select-option value="0">自定义</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="剂型" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }" :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
            <a-select v-model="search.form">
              <a-select-option value="">--请选择--</a-select-option>
              <a-select-option v-for="item in init.forms" :key="item.name" :value="item.name">{{item.value}}</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="业务状态">
            <a-select v-model="search.status">
              <a-select-option value="">--请选择--</a-select-option>
              <a-select-option v-for="item in init.statuses" :key="item.name" :value="item.name">
                {{ item.value }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="关键字">
            <a-input v-model="search.keyword" placeholder="请输入药品名称/首拼模糊检索">
              <img class="search-btn" slot="addonAfter" src="../../../assets/img/search.png" @click="searchAction"/>
            </a-input>
          </a-form-item>
        </a-row>
        <a-row class="searchrow width-style-auto">
          <a-button class="custom-primary-btn" size="default" icon="plus-circle" @click="addAction">新增药品</a-button>
          <a-button class="custom-primary-btn" size="default" icon="check-circle" @click="batchOnSaleAction"
                    style="margin-left: 10px">批量上架
          </a-button>
          <a-button class="custom-warn-btn" size="default" icon="file-excel" @click="batchOffSaleAction"
                    style="margin-left: 10px">批量下架
          </a-button>
          <a-button class="custom-danger-btn" size="default" icon="close-circle" @click="batchCancleAction"
                    style="margin-left: 10px;">批量作废
          </a-button>
          <a-button class="custom-warn-btn" size="default" icon="download" @click="downloadAction"
                    style="margin-left: 40px">下载导入模板
          </a-button>
          <a-upload :custom-request="uploadAction" :showUploadList="false">
            <a-button class="custom-primary-btn" size="default" icon="upload" style="margin-left: 10px">批量导入</a-button>
          </a-upload>

        </a-row>
      </a-form>
      <a-row class="search"></a-row>
      <a-table size="middle" :columns="grid.columns" :loading="grid.loading"
               :rowSelection="{fixed:true, selectedRowKeys: grid.selections, onChange: onSelectChange}"
               rowKey="id" :dataSource="grid.data" :scroll="{ x: '100%' }" :pagination="grid.pagination"
               @change="gridChangeAction">
              <span slot="status" slot-scope="text, record">
                <a-switch :disabled="record.status=='CANCELED'" @click="saleAction($event,record.id)"
                          checkedChildren="已上架" unCheckedChildren="已下架" checked-children="开" un-checked-children="关"
                          :checked="record.status=='ON_SALE'"/>
              </span>
        <span slot="operate" slot-scope="text, record">
                  <a class="custom-primary-act" v-if="!record.hq" :disabled="record.status=='CANCELED'"
                     @click="()=>editAction(record.id)">修改</a>
                  <a class="custom-primary-act" v-if="record.hq" :disabled="record.status=='CANCELED'"
                     @click="()=>editHqAction(record.id)">修改</a>
                  <a-divider type="vertical"/>
                  <a class="custom-warn-act" :disabled="record.status=='CANCELED'" @click="()=>cancelAction(record.id)">作废</a>
                </span>
      </a-table>
    </a-spin>
    <a-modal title="导入药品" :visible="modal.visible" width="95%" :maskClosable="false" @cancel="closeModal" @ok="submitAction" okText="确认导入">
      <a-spin :spinning="modal.loading" :tip="modal.loadTip">
        <a-table size="middle" :columns="modal.grid.columns" :loading="modal.grid.loading"
                 rowKey="id" :dataSource="modal.grid.data" :scroll="{ x: '100%', y:'400px' }">
                  <span slot="operate" slot-scope="text, record">
                    <a class="custom-warn-act" :disabled="record.status=='CANCELED'">删除</a>
                  </span>
        </a-table>
      </a-spin>
    </a-modal>
  </div>

</template>

<script>
import axios from "axios";

export default {
  name: "Drug",
  data() {
    return {
      loading: false,
      loadTip: '正在加载数据....',
      init: {
        types: [],
        organs: [],
        forms:[],
        statuses: statuses
      },
      search: {
        type: '',
        form:'',
        keyword: '',
        hq: '',
        status: ''
      },
      grid: {
        loading: false,
        columns: columns,
        data: [],
        selections: [],
        pagination: this.$pagination
      },
      modal: {
        visible: false,
        loading: false,
        loadTip: '',
        grid: {
          columns: excelColumns,
          data: [],
        }

      }
    }
  },
  beforeCreate() {
    let data = [{
      text: "首页",
      path: ""
    }, {
      text: "云药房",
      path: ""
    }, {
      text: "药品管理",
      path: ""
    }];
    this.$store.commit('updateBreadcrumb', data);
  },
  mounted() {
    let self = this;
    this.loadDrugType();
    this.searchAction();
    this.getDrugForms(function (res) {
      self.init.forms = res;
    });
  },
  methods: {

    loadDrugType: function () {
      let self = this;
      this.$axios.get('/api/dmz/dict/drug/types', {}).then(function (res) {
        if (res.msg.flag == 0) {
          self.init.types = res.biz;
        }
      })
    },

    buildParams: function () {
      return {
        'entity.type': this.search.type,
        'entity.form':  this.search.form,
        'entity.keyword': this.search.keyword,
        'entity.hq': ('1' == this.search.hq ? true : ('0' == this.search.hq ? false : null)),
        'entity.status': this.search.status,
      };
    },

    editAction: function (id) {
      this.$router.push({path: '/layout/pharmacy/drug/edit?id=' + id});
    },

    editHqAction: function (id) {
      this.$router.push({path: '/layout/pharmacy/drug/hqedit?id=' + id});
    },

    addAction: function () {
      this.$router.push({path: '/layout/pharmacy/drug/create'});
    },
    /**
     * 搜索按钮点击动作
     */
    searchAction: function () {
      Object.assign(this.grid, {pagination: Object.assign(this.grid.pagination, {current: 1})});
      let params = Object.assign(this.buildParams(), {start: 0, length: this.grid.pagination.pageSize});
      this.loadGrid(params);
    },

    /**
     * 分页条操作
     */
    gridChangeAction: function (pagination, filters, sorter) {
      Object.assign(this.grid, {pagination: pagination});
      let params = Object.assign(this.buildParams(), {
        start: (pagination.current - 1) * pagination.pageSize,
        length: pagination.pageSize
      });
      this.loadGrid(params);
    },

    /**
     *  行选择事件
     */
    onSelectChange: function (selectedRowKeys) {
      this.grid.selections = selectedRowKeys;
    },

    /**
     * 查询药品
     */
    loadGrid: function (params) {
      const self = this;
      self.grid.loading = true;
      self.$axios.get('/api/clinic/drug/list', {params: params}).then(function (res) {
        self.grid.loading = false;
        if (res.msg.flag == 0) {
          if (null == res.biz || res.biz.empty) {
            self.$message.info({content: res.msg.message, duration: 2});
            Object.assign(self.grid, {data: [], pagination: Object.assign(self.grid.pagination, {total: 0})});
          } else {
            Object.assign(self.grid, {
              data: res.biz.data,
              pagination: Object.assign(self.grid.pagination, {total: res.biz.count})
            });
          }
        } else {
          self.$message.error({content: res.msg.message, duration: 2});
        }
      }, function () {
        self.grid.loading = false;
      });
    },

    saleAction: function (e, drugId) {
      if (e) {
        this.onSaleSubmit([drugId])
      } else {
        this.offSaleSubmit([drugId])
      }
    },

    batchOnSaleAction: function (e) {
      if (null == this.grid.selections || this.grid.selections.length <= 0) {
        this.$message.info({content: '请选择需要上架的药品记录.', duration: 2});
        return;
      }
      this.onSaleSubmit(this.grid.selections)
    },

    onSaleSubmit: function (ids) {
      let self = this;

      self.loadTip = '正在提交数据....';
      self.loading = true;
      this.$axios.post('/api/clinic/drug/onsale', ids).then(function (res) {
        self.loading = false;
        if (res.msg.flag == 0) {
          self.$message.success({content: '操作成功.', duration: 2});
          self.grid.selections = [];
          self.gridChangeAction(self.grid.pagination)
        } else {
          self.$message.error({content: res.msg.message, duration: 2});
        }
      }).catch(function (err) {
        self.grid.loading = false;
        console.info(err)
        self.$message.error({content: '操作失败', duration: 2});
      })
    },

    batchOffSaleAction: function (e) {
      if (null == this.grid.selections || this.grid.selections.length <= 0) {
        this.$message.info({content: '请选择需要下架的药品记录.', duration: 2});
        return;
      }
      this.offSaleSubmit(this.grid.selections)
    },

    offSaleSubmit: function (ids) {
      let self = this;
      self.loadTip = '正在提交据....';
      self.loading = true;
      this.$axios.post('/api/clinic/drug/offsale', ids).then(function (res) {
        self.loading = false;
        if (res.msg.flag == 0) {
          self.$message.success({content: '操作成功.', duration: 2});
          self.grid.selections = [];
          self.gridChangeAction(self.grid.pagination)
        } else {
          self.$message.error({content: res.msg.message, duration: 2});
        }
      }).catch(function (err) {
        self.loading = false;
        console.info(err)
        self.$message.error({content: '操作失败', duration: 2});
      })
    },

    batchCancleAction: function (e) {
      if (null == this.grid.selections || this.grid.selections.length <= 0) {
        this.$message.info({content: '请选择需要作废的药品记录.', duration: 2});
        return;
      }
      this.cancelSubmit(this.grid.selections)
    },

    cancelAction: function (drugId) {
      this.cancelSubmit([drugId])
    },

    cancelSubmit: function (ids) {
      let self = this;

      self.loadTip = '正在提交数据....';
      self.loading = true;
      this.$axios.post('/api/clinic/drug/cancel', ids).then(function (res) {
        self.loading = false;
        if (res.msg.flag == 0) {
          self.$message.success({content: '操作成功.', duration: 2});
          self.grid.selections = [];
          self.gridChangeAction(self.grid.pagination)
        } else {
          self.$message.error({content: res.msg.message, duration: 2});
        }
      }).catch(function (err) {
        self.loading = false;
        console.info(err)
        self.$message.error({content: '操作失败', duration: 2});
      })

    },

    /**
     * 下载导入模板
     */
    downloadAction: function () {
      let self = this;

      self.loadTip = '正在下载模板....';
      this.loading = true;
      let token = null;
      if (localStorage.token) {
        token = JSON.parse(localStorage.token);
      }
      axios({
        baseURL: self.$axios.baseURL,
        url: '/api/clinic/drug/export',
        method: 'POST',
        responseType: 'blob',
        headers: {
          'Authorization': "Bearer " + token.access_token
        },
        data: {}
      }).then(function (res) {
        self.loading = false;
        let content = res;
        let blob = new Blob([content]);
        if ('download' in document.createElement('a')) {
          let link = document.createElement('a');
          link.download = '药品导入模板.xls';
          link.style.display = 'none';
          link.href = URL.createObjectURL(blob);
          document.body.append(link);
          link.click();
          URL.revokeObjectURL(link.href);
          document.body.removeChild(link);
        } else {
          navigator.msSaveBlob(blob);
        }
      }).catch(function (err) {
        console.info(err);
        self.loading = false;
        self.$message.error({content: '下载模板失败'});
      })

    },

    /**
     * 导入动作
     */
    uploadAction: function (src) {
      const self = this;
      const isLt = src.file.size / 1024 / 1024 < 10;
      if (!isLt) {
        self.$message.error({content: '文件大小少于10M.', duration: 2});
        return false;
      }
      let params = new FormData();
      params.append("file", src.file);
      this.loadTip = '正在解析数据....';
      this.loading = true;
      this.$axios.post('/api/clinic/drug/analysis', params, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }, timeout: 1000 * 60 * 15
      }).then(function (res) {
        console.info(res)
        self.loading = false;
        if (res.msg.flag == 0) {
          self.$message.success({content: '解析成功'});

          let datas = (res.biz||[]).sort(function (a, b) {
            if((undefined === a.message || null === a.message || '' === a.message) && (undefined === b.message || null === b.message || '' === b.message)){
              return 0;
            }else if(undefined != a.message && null != a.message && '' != a.message){
              return -1;
            }else if(undefined != b.message && null != b.message && '' != b.message){
              return 1;
            }
            return 0;
          });

          self.modal.grid.data = datas;
          self.modal.visible = true;
        } else {
          self.$message.error({content: res.msg.message, duration: 2});
        }
      }, function () {
        self.loading = false;
      });

      return false;
    },

    /**
     * 关闭窗口
     */
    closeModal: function () {
      this.modal.grid.data = [];
      this.modal.visible = false;
    },

    /**
     * 提交导入
     */
    submitAction: function () {
      console.info(this.modal.grid.data)
      let self = this;
      self.$confirm({
        title: '您确定要将解析的数据导入系统吗？',
        okText: '药品导入',
        onOk() {
          self.modal.loadTip = '正在导入药品信息,请稍候...';
          self.modal.loading = true;
          self.$axios.post('/api/clinic/drug/import', self.modal.grid.data, {
            timeout: 1000 * 60 * 15
          }).then(function (res) {
            self.modal.loading = false;
            if (res.msg.flag == 0) {
              self.$message.success({content: '药品导入成功.', duration: 2});
              self.modal.grid.data = [];
              self.modal.visible = false;
              self.gridChangeAction(self.grid.pagination);
            } else {
              self.$message.error({content: res.msg.message, duration: 2});
            }
          }, function (res) {
            self.modal.loading = false;
          });
        },
      });
    }

  }
}

let statuses = [
  {name: 'ON_SALE', value: '已上架'},
  {name: 'OFF_SALE', value: '已下架'},
  {name: 'CANCELED', value: '已作废'},
];


let columns = [
  {
    title: '药品名称',
    dataIndex: 'name',
    key: 'name',
    align: 'center',
    customRender: (text, record, index) => {
      return text == null || text == undefined ? '-' : text;
    },
    width: 180
  },
  {
    title: '药品归属',
    dataIndex: 'hq',
    key: 'hq',
    align: 'center',
    customRender: (text, record, index) => {
      return text == null || text == undefined ? '-' : (text ? '总部' : '自定义');
    },
    width: 120
  },
  {
    title: '药品类型',
    dataIndex: 'typeName',
    key: 'typeName',
    align: 'center',
    customRender: (text, record, index) => {
      return text == null || text == undefined ? '-' : text;
    },
    width: 120
  },
  {
    title: '别名',
    dataIndex: 'alias',
    key: 'alias',
    align: 'center',
    customRender: (text, record, index) => {
      return text == null || text == undefined || text.length == 0 ? '-' : text.join(',');
    },
    width: 160
  },
  {
    title: '规格',
    dataIndex: 'spec',
    key: 'spec',
    align: 'center',
    customRender: (text, record, index) => {
      return text == null || text == undefined || text.length == 0 ? '-' : text;
    },
    width: 120
  },
  {
    title: '剂型',
    dataIndex: 'form',
    key: 'drugForm',
    align: 'center',
    customRender: (text, record, index) => {
      return text == null || text == undefined || text.length == 0 ? '-' : text;
    },
    width: 100
  },
  {
    title: '销售单位',
    dataIndex: 'salesUnit',
    key: 'salesUnit',
    align: 'center',
    customRender: (text, record, index) => {
      return text == null || text == undefined || text.length == 0 ? '-' : text;
    },
    width: 100
  },
  {
    title: '最小单位',
    dataIndex: 'minUnit',
    key: 'minUnit',
    align: 'center',
    customRender: (text, record, index) => {
      return text == null || text == undefined || text.length == 0 ? '-' : text;
    },
    width: 100
  },
  {
    title: '生产厂家',
    dataIndex: 'manufacturer',
    key: 'manufacturer',
    align: 'center',
    customRender: (text, record, index) => {
      return text == null || text == undefined || text.length == 0 ? '-' : text;
    },
    width: 180
  },
  {
    title: '状态',
    dataIndex: 'statusName',
    key: 'statusName',
    align: 'center',
    scopedSlots: {customRender: 'status'},
    width: 120
  },
  {
    title: '操作',
    key: 'operate',
    align: 'center',
    width: 180,
    scopedSlots: {customRender: 'operate'}
  }

]

let excelColumns = [
  {
    title: '错误描述',
    dataIndex: 'message',
    key: 'message',
    align: 'center',
    customRender: (text, record, index) => {
      return text == null || text == undefined ? '-' : text;
    },
    width: 120
  },
  {
    title: '药品名称',
    dataIndex: 'name',
    key: 'name',
    align: 'center',

    customRender: (text, record, index) => {
      return text == null || text == undefined ? '-' : text;
    },
    width: 120
  },
  {
    title: '匹配状态',
    dataIndex: 'drugId',
    key: 'drugId',
    align: 'center',
    customRender: (text, record, index) => {
      return text == null || text == undefined || text == '' ? '未匹配' : '已匹配';
    },
    width: 120
  },
  {
    title: '是否总部',
    dataIndex: 'hq',
    key: 'hq',
    align: 'center',
    customRender: (text, record, index) => {
      return (record.drugId == null || record.drugId == undefined || record.drugId == '') ? '-' : (text == null || text == undefined ? '-' : (text ? '总部' : '自定义'));
    },
    width: 120
  },
  {
    title: '药品别名',
    dataIndex: 'alias',
    key: 'alias',
    align: 'center',
    customRender: (text, record, index) => {
      return text == null || text == undefined ? '-' : text;
    },
    width: 180
  },
  {
    title: '药品分类',
    dataIndex: 'type',
    key: 'type',
    align: 'center',
    customRender: (text, record, index) => {
      return text == null || text == undefined ? '-' : text;
    },
    width: 90
  },
  {
    title: '规格',
    dataIndex: 'spec',
    key: 'spec',
    align: 'center',
    customRender: (text, record, index) => {
      return text == null || text == undefined ? '-' : text;
    },
    width: 90
  },
  {
    title: '剂型',
    dataIndex: 'form',
    key: 'form',
    align: 'center',
    customRender: (text, record, index) => {
      return text == null || text == undefined ? '-' : text;
    },
    width: 90
  },
  {
    title: '销售单位',
    dataIndex: 'saleUnit',
    key: 'saleUnit',
    align: 'center',
    customRender: (text, record, index) => {
      return text == null || text == undefined ? '-' : text;
    },
    width: 75
  },
  {
    title: '销售单价',
    dataIndex: 'price',
    key: 'price',
    align: 'center',
    customRender: (text, record, index) => {
      return text == null || text == undefined ? '-' : text;
    },
    width: 75
  },
  {
    title: '发票',
    dataIndex: 'invoice',
    key: 'invoice',
    align: 'center',
    customRender: (text, record, index) => {
      return text == null || text == undefined ? '-' : text;
    },
    width: 90
  },
  {
    title: '是否允许拆零',
    dataIndex: 'scattered',
    key: 'scattered',
    align: 'center',
    customRender: (text, record, index) => {
      return text == null || text == undefined ? '-' : text;
    },
    width: 75
  },
  {
    title: '拆零单位',
    dataIndex: 'minUnit',
    key: 'minUnit',
    align: 'center',
    customRender: (text, record, index) => {
      return text == null || text == undefined ? '-' : text;
    },
    width: 75
  },
  {
    title: '拆零换算比例',
    dataIndex: 'rate',
    key: 'rate',
    align: 'center',
    customRender: (text, record, index) => {
      return text == null || text == undefined ? '-' : text;
    },
    width: 75
  },
  {
    title: '拆零单价',
    dataIndex: 'minPrice',
    key: 'minPrice',
    align: 'center',
    customRender: (text, record, index) => {
      return text == null || text == undefined ? '-' : text;
    },
    width: 75
  },
  {
    title: '推荐剂量单位',
    dataIndex: 'dosageUnit',
    key: 'dosageUnit',
    align: 'center',
    customRender: (text, record, index) => {
      return text == null || text == undefined ? '-' : text;
    },
    width: 75
  },
  {
    title: '推荐最小剂量',
    dataIndex: 'dosageStart',
    key: 'dosageStart',
    align: 'center',
    customRender: (text, record, index) => {
      return text == null || text == undefined ? '-' : text;
    },
    width: 75
  },
  {
    title: '推荐最大剂量',
    dataIndex: 'dosageEnd',
    key: 'dosageEnd',
    align: 'center',
    customRender: (text, record, index) => {
      return text == null || text == undefined ? '-' : text;
    },
    width: 75
  },
  {
    title: '药品条码',
    dataIndex: 'barCode',
    key: 'barCode',
    align: 'center',
    customRender: (text, record, index) => {
      return text == null || text == undefined ? '-' : text;
    },
    width: 90
  },
  {
    title: '生产厂家',
    dataIndex: 'manufacturer',
    key: 'manufacturer',
    align: 'center',
    customRender: (text, record, index) => {
      return text == null || text == undefined ? '-' : text;
    },
    width: 160
  },
  {
    title: '批准文号',
    dataIndex: 'approval',
    key: 'approval',
    align: 'center',
    customRender: (text, record, index) => {
      return text == null || text == undefined ? '-' : text;
    },
    width: 120
  },
  {
    title: '采购价',
    dataIndex: 'cost',
    key: 'cost',
    align: 'center',
    customRender: (text, record, index) => {
      return text == null || text == undefined ? '-' : text;
    },
    width: 90
  },
  {
    title: '剩余库存',
    dataIndex: 'stockQty',
    key: 'stockQty',
    align: 'center',
    customRender: (text, record, index) => {
      return text == null || text == undefined ? '-' : text;
    },
    width: 90
  },
  {
    title: '库存预警值',
    dataIndex: 'alert',
    key: 'alert',
    align: 'center',
    customRender: (text, record, index) => {
      return text == null || text == undefined ? '-' : text;
    },
    width: 90
  },
  {
    title: '成本价',
    key: 'costPrice',
    align: 'center',
    customRender: (text, record, index) => {
      return (record.cost == null || record.cost == undefined)? '-' : record.cost;
    },
    width: 90
  },
  {
    title: '主治',
    dataIndex: 'indications',
    key: 'indications',
    align: 'center',
    customRender: (text, record, index) => {
      return text == null || text == undefined ? '-' : text;
    },
    width: 120
  },
  {
    title: '用法',
    dataIndex: 'usage',
    key: 'usage',
    align: 'center',
    customRender: (text, record, index) => {
      return text == null || text == undefined ? '-' : text;
    },
    width: 120
  },
  {
    title: '功能',
    dataIndex: 'functions',
    key: 'functions',
    align: 'center',
    customRender: (text, record, index) => {
      return text == null || text == undefined ? '-' : text;
    },
    width: 120
  },
  {
    title: '名称解释',
    dataIndex: 'explain',
    key: 'explain',
    align: 'center',
    customRender: (text, record, index) => {
      return text == null || text == undefined ? '-' : text;
    },
    width: 120
  },
  {
    title: '性状',
    dataIndex: 'trait',
    key: 'trait',
    align: 'center',
    customRender: (text, record, index) => {
      return text == null || text == undefined ? '-' : text;
    },
    width: 120
  },
  {
    title: '性味',
    dataIndex: 'flavour',
    key: 'flavour',
    align: 'center',
    customRender: (text, record, index) => {
      return text == null || text == undefined ? '-' : text;
    },
    width: 120
  },
]
</script>

<style scoped>

</style>
